<template>
  <div class="modal fade contact_form_modal" id="reviewModal" @click.self="$emit('close')">
    <div class="modal-dialog modal-dialog-centered modal-container--extra-large" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-content">
            <autocomplete @selectName="selectBuilding"
                          :placeholder="'Поиск по названию ЖК'" v-model="building_name">
            </autocomplete>
            <ul class="contest-buildings-list mt-5">
              <li v-for="(building) in buildings" class="contest-buildings-list__item" @click.prevent="selectBuilding(building.id)">{{building.name}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import autocomplete from "./autocomplete";
  export default {
    components: {autocomplete},
    data() {
      return {
        buildings: [],
        building_item:{},
        building_name:"",
      }
    },
    methods: {
      getBuildings() {
        axios.get('/api/contest/building-list')
        .then((response) => {
          this.buildings = response.data;
        })
      },
      selectBuilding(id) {
        axios.post('/api/contest/select-building', {id:id})
        .then((response) => {
          this.building_item = response.data;
          this.$emit('select-building',response.data);
        })
      },

    },
    mounted() {
      this.getBuildings();
    }
  }
</script>